import React from 'react';
import { CarouselStyle } from '@/types';
import { Slider } from '@/components/ui/slider';
import { cn } from '@/lib/utils';
import { Users, Pencil } from 'lucide-react';

export interface AdvancedOptionsValue {
  style: CarouselStyle;
  slideCount: number;
  avatarOverride: string | null;
}

interface Props {
  value: AdvancedOptionsValue;
  onChange: (next: AdvancedOptionsValue) => void;
  avatarHandleLabel: string | null;
  onEditAvatar: () => void;
}

const styleOptions: Array<{ id: CarouselStyle; label: string }> = [
  { id: CarouselStyle.TWITTER, label: 'Twitter' },
  { id: CarouselStyle.STORYTELLER, label: 'Storyteller' },
];

export const ChatAdvancedOptions: React.FC<Props> = ({
  value,
  onChange,
  avatarHandleLabel,
  onEditAvatar,
}) => {
  return (
    <div
      data-tour="chat-advanced-options"
      className="border border-border rounded-xl bg-muted/20 px-4 py-3 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm"
    >
      <div>
        <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1.5">Estilo</p>
        <div className="flex gap-1.5">
          {styleOptions.map((opt) => (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange({ ...value, style: opt.id })}
              className={cn(
                'px-2.5 py-1 rounded-md border text-xs transition-colors',
                value.style === opt.id
                  ? 'border-primary bg-primary/15 text-primary'
                  : 'border-border bg-transparent text-muted-foreground hover:text-foreground',
              )}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1.5">Slides</p>
        <div className="flex items-center gap-3">
          <span className="text-xs text-muted-foreground">3</span>
          <Slider
            value={[value.slideCount]}
            onValueChange={(v) => onChange({ ...value, slideCount: v[0] })}
            min={3}
            max={15}
            step={1}
            className="flex-1"
          />
          <span className="w-6 text-center font-semibold">{value.slideCount}</span>
        </div>
      </div>

      <div>
        <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1.5">Avatar</p>
        <button
          type="button"
          onClick={onEditAvatar}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-border text-xs hover:bg-muted/40"
        >
          <Users className="h-3.5 w-3.5" />
          {avatarHandleLabel ?? 'Configurar'}
          <Pencil className="h-3 w-3 opacity-60" />
        </button>
      </div>
    </div>
  );
};
